import { memo } from "react";
import * as Bananas from "bananas-commerce-admin";

import AddIcon from "@mui/icons-material/Add";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import { Box, Button, Stack } from "@mui/material";

import { useObituaryDialog } from "@/extensions/obituary/contexts/ObituaryDialogContext";

const Actions = () => {
  return (
    <>
      <Box sx={{ display: { sm: "flex", xs: "none" } }}>
        <Bananas.ActionBar>
          <Buttons />
        </Bananas.ActionBar>
      </Box>
      <Stack
        direction="column-reverse"
        gap={1}
        sx={{
          display: { sm: "none", xs: "flex" },
          p: 2,
          position: "sticky",
          bottom: 80,
          zIndex: 1,
          bgcolor: "background.default",
          borderTopWidth: 1,
          borderTopStyle: "solid",
          borderTopColor: "divider",
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
        }}
      >
        <Buttons />
      </Stack>
    </>
  );
};

export default memo(Actions);

const Buttons = () => {
  const { openDialog } = useObituaryDialog();

  return (
    <>
      <Button
        startIcon={<MailOutlineIcon />}
        variant="outlined"
        onClick={openDialog?.("proof")}
      >
        Skicka korrektur
      </Button>

      <Button
        startIcon={<NewspaperIcon />}
        variant="outlined"
        onClick={openDialog?.("publish")}
      >
        Boka annonser
      </Button>

      <Button
        startIcon={<AddIcon />}
        variant="contained"
        onClick={openDialog?.("create")}
      >
        Skapa ny annons
      </Button>
    </>
  );
};
